import { Analytics, AnalyticsOutlined, AnalyticsSharp, BrowseGallery, Category, Dashboard, Pages, People, PeopleOutline, Settings, Store } from "@mui/icons-material";
import { Divider, Grid, List, ListItemButton, ListItemText, Typography } from "@mui/material";
import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

export default function AdminSidebar() {

    var loc = useLocation();
    var navi = useNavigate();

    const [paths, setpaths] = useState([
        { Name: 'Dashboard', icon: <Dashboard sx={{ fontSize: 20 }} />, Path: '/Admin/Dashboard' },
        { Name: 'Customer', icon: <People sx={{ fontSize: 20 }} />, Path: '/Admin/Customer' },
        { Name: 'Clients', icon: <People sx={{ fontSize: 20 }} />, Path: '/Admin/Clients' },
        { Name: 'Users', icon: <People sx={{ fontSize: 20 }} />, Path: '/Admin/User' },
        { Name: 'Categories', icon: <Category sx={{ fontSize: 20 }} />, Path: '/Admin/Categories' },
        // { Name: 'Pages', icon: <Pages sx={{ fontSize: 20 }} />, Path: '/Admin/Pages' },
        { Name: 'Analytics', icon: <AnalyticsSharp sx={{ fontSize: 20 }} />, Path: '/Admin/Analytics' },
        { Name: 'Team', icon: <PeopleOutline sx={{ fontSize: 20 }} />, Path: '/Admin/Team' },
        { Name: 'Contact Requests', icon: <PeopleOutline sx={{ fontSize: 20 }} />, Path: '/Admin/ContactRequests' },
        { Name: 'Pages', icon: <Pages sx={{ fontSize: 20 }} />, Path: '/Admin/Pages' },
        { Name: 'Cities', icon: <Pages sx={{ fontSize: 20 }} />, Path: '/Admin/Cities' },
        { Name: 'Chat', icon: <Pages sx={{ fontSize: 20 }} />, Path: '/Admin/Chat' },
        { Name: 'Integration', icon: <Pages sx={{ fontSize: 20 }} />, Path: '/Admin/Integration' },
        { Name: 'Settings', icon: <Settings sx={{ fontSize: 20 }} />, Path: '/Admin/Settings' },
    ]);

    return (
        <>

            <Grid size={{ xs: 12, lg: 2 }} bgcolor={'#0F1536'} className='text-white' textAlign={'center'} height={'100vh'} overflow={'hidden'}>
                <Typography variant="h5" fontWeight={'bold'} className="mt-3">BookYourSalon</Typography>
                {/* <hr className="text-black" /> */}
                {/* <Divider /> */}
                {/* <br /> */}
                {/* <br /> */}
                {/* <br /> */}
                {/* <Link className="admin-list">Dashboard</Link> */}
                {/* <List> */}
                {/* <ListItemButton> */}
                {/* <ListItemText title="Dashboard" className="text-black" /> */}
                {/* </ListItemButton> */}
                {/* </List> */}
                <Grid height={'92vh'} mt={2} sx={{ overflowY: 'auto' }}>
                    {paths.map((row) => (
                        row.Path == loc.pathname ? (

                            <Grid className='admin-list-item-selected  mt-1'>
                                <Grid className="bg-admin-selected text-white">
                                    {row.icon}
                                </Grid>
                                <Typography variant="h6" className="ms-2 text-white">{row.Name}</Typography>
                            </Grid>
                        ) : (
                            <Grid onClick={() => navi(row.Path)} className='admin-list-item mt-1'>
                                <Grid className="bg-admin shadow">
                                    {row.icon}
                                </Grid>
                                <Typography variant="h6" className="ms-2" color="grey">{row.Name}</Typography>
                            </Grid>
                        )
                    ))}
                    <br />
                    {/* <Grid className='admin-list-item'>
                        <Grid className="bg-admin shadow">
                            <Store sx={{ fontSize: 21 }} />
                        </Grid>
                        <Typography variant="h6" className="ms-2">Shops</Typography>
                    </Grid> */}
                    {/* <Grid className='admin-list-item'>
                        <Grid className="bg-admin shadow">
                            <Dashboard sx={{fontSize:20}} />
                        </Grid>
                        <Typography variant="h6" className="ms-2">Dashboard</Typography>
                    </Grid> */}

                </Grid>
            </Grid>

        </>
    )


}